import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGas"><Path d="M15.5 20.5H16.5M15.5 20.5V3.5H4.5V20.5M15.5 20.5H4.5M3.5 20.5H4.5M15.5 9.5H18.5V17.5H21.5V7.5L19.5 5.5M12.5 9.5H7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGas;
